module.exports = __webpack_public_path__ + "media/images/sp/banner/mitsubachi-25710be7d2359c6c9188dbbd5cc46c37.png";